import { JsonServiceClient } from '@servicestack/client';
export default class ServiceClient extends JsonServiceClient {
  constructor(baseUrl: string = '/api') {
    super(baseUrl);
    this.requestFilter = (req) => req.headers.append('x-tm3-date', new Date().toJSON());
  }
}
